import { templateMapping } from 'public/Utilities/misc';
import wixLocationFrontend from "wix-location-frontend";
import { local as storage } from "wix-storage";
import { getDropdownOptions, getHighPricedProducts, getProductIds, getProductsByIds, getProductBySlug } from 'backend/stores.web.js';
import { viewMode } from 'wix-window-frontend';
import { getProductVariantsOptions, debouncedAddToCart, debouncedQuickView, formatPrice } from 'public/Utilities/common';
import _ from 'lodash';
var store = require('store');

export async function detectProductPage() {
    const path = wixLocationFrontend.url;

    const productPageMatch = path.match(/\/product-page\/(.+)/);

    if (productPageMatch) {
        const productIdOrName = productPageMatch[1];

        const product = await getProductBySlug(productIdOrName);
        if (product) {
            addProductToRecent(product);
        } else {
            // console.log("No matching product found.");
        }
    }
}

export function addProductToRecent(product) {
    const storedProducts = storage.getItem('recentProducts');
    let recentProducts = storedProducts ? JSON.parse(storedProducts) : [];

    // Check for duplicate products
    const isProductInList = recentProducts.some(p => p._id === product._id);

    if (!isProductInList) {
        recentProducts = [product, ...recentProducts];
        storage.setItem('recentProducts', JSON.stringify(recentProducts));
    }
}

export async function getRecentProducts() {

    let instance = store.get('instance');
    // Get the recent product IDs from localStorage
    let recentProductIds = [];
    if (instance && instance.instance && instance.instance.aid) {
        recentProductIds = await getProductIds(instance.instance.aid);
    }
    const queriedProducts = await getProductsByIds(recentProductIds);

    // If no IDs are stored, return an empty array
    if (!recentProductIds) {
        return [];
    }

    // Filter the productsFromBackend to match the IDs stored in localStorage
    const recentProducts = queriedProducts;
    store.set('recentProducts', recentProducts);

    // Sort the recentProducts based on the order of productIds in recentProductIds
    const sortedRecentProducts = recentProducts.sort((a, b) => {
        return recentProductIds.indexOf(a._id) - recentProductIds.indexOf(b._id);
    });

    return sortedRecentProducts;
}

// Helper function to set up the repeater
async function setupRepeater(clipData, repeaterId, elementSelectors, props) {
    let dropdownOptions = await getDropdownOptions(clipData);
    $w(repeaterId).data = clipData;

    $w(repeaterId).onItemReady(async ($item, itemData) => {
        // Handle image, title, description, and price visibility
        handleVisibilityAndContent($item, itemData, props, elementSelectors);

        // Set dropdown options
        let options = await getProductVariantsOptions(dropdownOptions, itemData._id);
        $item(elementSelectors.dropDownElement).options = options;

        // Set selectedIndex to 0 only if there are options
        if (options.length > 0) {
            $item(elementSelectors.dropDownElement).selectedIndex = 0;
        }

        let firstIndexValue = options.length > 0 ? options[0].value : null;

        let showVariantDropDownCondition = props.showVariantDropdowns === 'show' && options.length > 1;
        if (showVariantDropDownCondition) {
            $item(elementSelectors.dropDownElement).show();
            $item(elementSelectors.dropDownElement).expand();
        } else {
            $item(elementSelectors.dropDownElement).hide();
            $item(elementSelectors.dropDownElement).collapse();
        }

        if (props.showProductAddToCartButtonToggleValue) {
            $item(elementSelectors.buttonElement).show();
            $item(elementSelectors.buttonElement).expand();
            $item(elementSelectors.buttonElement).onClick(() => {
                if (showVariantDropDownCondition) {
                    debouncedAddToCart($item(elementSelectors.dropDownElement).value);
                } else {
                    debouncedAddToCart(firstIndexValue || itemData._id);
                }
            });
        } else {
            $item(elementSelectors.buttonElement).hide();
            $item(elementSelectors.buttonElement).collapse();
        }

        $item(elementSelectors.quickViewButtonElement).onClick(() => {

            debouncedQuickView(itemData._id);
        });
    });
}

export async function multiStatefeedCardRepeater(clipData, props, isMobile) {
    let isDataAvailable = clipData.length >= props.noOfItemsForSlider;
    if (isDataAvailable) {
        $w('#widgetContainer').show();
        $w('#widgetContainer').expand();
        let template = props.selectedTemplate;
        let itemCount = props.noOfItemsForSlider;
        if (isMobile) {
            itemCount = 1;
            template = 'template4'
        }

        const elementSelectors = templateMapping[template][itemCount];
        if (elementSelectors) {
            await setupRepeater(clipData, elementSelectors.repeaterId, elementSelectors, props);
        }
    } else if (!isDataAvailable) {
        if (props.newVisitorMethod == 'noWidget' && viewMode == 'Site') {
            $w('#widgetContainer').hide();
            $w('#widgetContainer').collapse();

        } else if (props.newVisitorMethod == 'highPriced') {
            let highPricedItems = await getHighPricedProducts(props.noOfItemsForSlider);

            const template = props.selectedTemplate;
            const itemCount = props.noOfItemsForSlider;
            const elementSelectors = templateMapping[template][itemCount];
            if (elementSelectors) {
                await setupRepeater(highPricedItems, elementSelectors.repeaterId, elementSelectors, props);
            }
        }
    }
}

// Function to handle visibility and content setting for various elements
function handleVisibilityAndContent($item, itemData, props, elementSelectors) {
    if (props.showProductImgToggleValue) {
        $item(elementSelectors.imgElement).show();
        $item(elementSelectors.imgElement).expand();
        $item(elementSelectors.imgElement).src = itemData.mainMedia;
        $item(elementSelectors.quickViewButtonElement).show();
        $item(elementSelectors.quickViewButtonElement).expand();
    } else {
        $item(elementSelectors.imgElement).hide();
        $item(elementSelectors.imgElement).collapse();
        $item(elementSelectors.quickViewButtonElement).hide();
        $item(elementSelectors.quickViewButtonElement).collapse();
    }
    if (props.showProductNameToggleValue) {
        $item(elementSelectors.titleElement).show();
        $item(elementSelectors.titleElement).expand();
        $item(elementSelectors.titleElement).text = itemData.name;
    } else {
        $item(elementSelectors.titleElement).hide();
        $item(elementSelectors.titleElement).collapse();
    }
    if (props.showProductDescriptionToggleValue) {
        $item(elementSelectors.descriptionElement).show();
        $item(elementSelectors.descriptionElement).expand();
        $item(elementSelectors.descriptionElement).text = itemData.description;
    } else {
        $item(elementSelectors.descriptionElement).hide();
        $item(elementSelectors.descriptionElement).collapse();
    }
    if (props.showProductPriceToggleValue) {
        $item(elementSelectors.priceElement).show();
        $item(elementSelectors.priceElement).expand();
        $item(elementSelectors.priceElement).text = formatPrice(itemData.currency, itemData.price);
    } else {
        $item(elementSelectors.priceElement).hide();
        $item(elementSelectors.priceElement).collapse();
    }
}